import {
  NavLink,
  TabType,
} from '@lmt/unicorn-shared/app/components/navigation/types';
import { pages } from '@lmt/unicorn-shared/app/constants/sharedRoutes';

export type NavigationState = {
  tabs: NavLink[];
  // Saves last active tab after user pressed `logOut`.
  // Needed for #46420: Store previous opened tabs on logout and on autologout
  lastActiveTabId: string | null;
  defaultTabs: NavLink[];
  tabStateChangeSubscribers: Array<TabStateChangeSubscriber | undefined>;
};

export type TabStateChangeSubscriber = (
  tabId: string,
  newState: 'opened' | 'removed',
) => void;

export const defaultNavigationState: NavigationState = {
  tabs: [],
  // Saves last active tab after user pressed `logOut`.
  // Needed for #46420: Store previous opened tabs on logout and on autologout
  lastActiveTabId: null,
  defaultTabs: defaultTabs(),
  tabStateChangeSubscribers: [],
};

export function defaultTabs(): NavLink[] {
  return [
    {
      id: 'dashboard',
      title: 'Dashboard',
      path: pages.dashboard.link(),
      permission: true,
      search: '',
    },
    {
      id: 'calendar',
      title: 'Calendar',
      path: pages.calendar.link(),
      permission: true,
      search: '',
    },
    {
      id: 'patients',
      title: 'Patients',
      path: pages.patients.link(),
      permission: true,
      search: '',
    },
  ];
}
